// TODO: define these per layer instead of globally. We're currently mixing Stagedoos and Volunteerly roles.
// The backend doesn't have a Volunteer role. No role means Volunteer. Also see getRole.ts.
export enum OrganizationRole {
  Admin = 'admin',
  Volunteer = 'volunteer',
  Student = 'student',
  Mentor = 'mentor',
}
